import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: '/client/idnloan',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login_callback',
      name: 'loginCallback',
      component: () => import('./views/LoginCallback.vue'),
      props: (route) => ({ succ: !!+route.query.success })
    },
    {
      path: '/intro/:id',
      name: 'introduction',
      component: () => import('./views/Introduction.vue'),
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/repay_help/:user_id',
      name: 'repayHelp',
      component: () => import('./views/RepayHelp.vue')
    },
    {
      path: '/intro/service_privacy',
      name: 'introduction',
      component: () => import('./views/ServicePrivacy.vue')
    },
    {
      path: '/service_privacy',
      name: 'servicePrivacy',
      component: () => import('./views/ServicePrivacy.vue')
    },
    {
      path: '/loan_protocol',
      name: 'loanProtocol',
      component: () => import('./views/LoanProtocol')
    },
    {
      path: '/order_history/:user_id',
      name: 'orderHistory',
      component: () => import('./views/OrderHistory.vue')
    },
    {
      path: '/order_history_detail/:user_id',
      name: 'orderHistory',
      component: () => import('./views/OrderHistoryDetail.vue')
    },
    {
      path: '/order_detail',
      name: 'orderDetail',
      component: () => import('./views/OrderDetail.vue')
    },
    {
      path: '/pdf_view',
      name: 'pdfView',
      component:()=>import('./views/PdfView.vue')
    },
    {
      path:'/digisign_reg',
      name:'digisign_reg',
      component:()=>import('./views/digisign_reg.vue')
    },
    {
      path:'/digisign_sign',
      name:'digisign_sign',
      component:()=>import('./views/digisign_sign.vue')
    }
  ]
});
